import type { ShuttleEpcLocales } from '@/types/lang/locales'

export const shuttleEpcEn: ShuttleEpcLocales = {
    api: {
        error: {
            createShuttleEpc: 'An error occurred while creating the shuttle EPC {name}',
            createShuttleEpcRange:
                'An error occurred while creating the shuttle EPCs from {start} to {end}',
            deleteShuttleEpc: 'An error occurred while deleting the shuttle EPC {name}',
            fetchShuttleEpcs: 'An error occurred while fetching the shuttle EPCs'
        },
        success: {
            createShuttleEpc: 'Shuttle EPC {name} successfully created!',
            createShuttleEpcRange:
                'Shuttle EPCs {start} to {end}: {created} created, {skipped} already existing',
            deleteShuttleEpc: 'Shuttle EPC {name} successfully deleted!',
            fetchShuttleEpcs: 'Shuttle EPCs successfully fetched!'
        }
    },
    buttons: {
        create: 'Add a shuttle EPC',
        createRange: 'Add a range of shuttle EPCs'
    },
    dialog: {
        createTitle: 'Add a shuttle EPC',
        epcPlaceholder: 'Enter the EPC code',
        createRangeTitle: 'Add a range of shuttle EPCs',
        rangeStart: 'First EPC',
        rangeEnd: 'Last EPC',
        rangeHint:
            'EPCs are numeric and incremented in base 10 (bounds included). Existing EPCs are skipped.',
        rangeCount: '{count} EPCs will be added',
        rangeErrors: {
            digits: 'EPCs must contain digits only',
            length: 'The first and last EPC must have the same length',
            order: 'The last EPC must be greater than or equal to the first one',
            max: 'A range cannot exceed {max} EPCs'
        }
    },
    model: {
        epc: 'EPC',
        createdAt: 'Creation date'
    },
    table: {
        id: 'ID',
        epc: 'EPC',
        createdAt: 'Creation date'
    }
}
